import { 
  DollarSign, 
  Target, 
  Users, 
  TrendingDown, 
  Scale, 
  Clock,
  AlertCircle,
  XCircle
} from "lucide-react";

const reasons = [
  {
    rank: 1,
    title: "Ran Out of Cash",
    percentage: "38%",
    icon: DollarSign,
    delegationLink: "Founders often handle all finances personally, missing critical runway signals. A delegated CFO or finance lead provides oversight while you focus on product.",
    color: "text-destructive"
  },
  {
    rank: 2,
    title: "No Market Need",
    percentage: "35%",
    icon: Target,
    delegationLink: "When founders are too busy coding or firefighting, they don't talk to customers. Delegate customer discovery to a product team that reports insights weekly.",
    color: "text-amber-500"
  },
  {
    rank: 3,
    title: "Got Outcompeted",
    percentage: "20%",
    icon: TrendingDown,
    delegationLink: "Competitors move faster when founders are bottlenecks. Empower teams to ship independently while you focus on strategic differentiation.",
    color: "text-orange-500"
  },
  {
    rank: 4,
    title: "Flawed Business Model",
    percentage: "19%",
    icon: Scale,
    delegationLink: "Founders too deep in operations miss unit economics problems. Delegate financial modeling to specialists who can flag issues early.",
    color: "text-blue-500"
  },
  {
    rank: 5,
    title: "Team Problems",
    percentage: "23%",
    icon: Users,
    delegationLink: "Ironically, poor delegation causes team problems. Micromanagement drives away top talent; they want ownership, not supervision.",
    color: "text-purple-500"
  },
  {
    rank: 6,
    title: "Burned Out",
    percentage: "8%",
    icon: Clock,
    delegationLink: "72% of founders report mental health impacts. Burnout is a direct result of refusing to delegate—you can't scale yourself.",
    color: "text-red-500"
  }
];

export const StartupFailureReasons = () => {
  return (
    <section className="py-10 sm:py-12">
      <h2 id="why-startups-fail" className="text-2xl sm:text-3xl font-bold text-foreground mb-4 flex items-center gap-2">
        <XCircle className="h-6 w-6 text-destructive" />
        Why Startups Fail: The Data
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        CB Insights analyzed 110+ failed startups to identify root causes. Notice how many trace back to founder bandwidth and delegation failures.
      </p>

      <div className="grid gap-4 sm:gap-6">
        {reasons.map((reason) => (
          <div 
            key={reason.rank}
            className="bg-card border border-border rounded-xl p-5 sm:p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`p-3 rounded-lg bg-muted shrink-0 ${reason.color}`}>
                <reason.icon className="h-6 w-6" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-lg font-semibold text-foreground">
                    #{reason.rank} {reason.title}
                  </h3>
                  <span className={`text-xl font-bold ${reason.color}`}>
                    {reason.percentage}
                  </span>
                </div>
                <p className="text-muted-foreground text-sm sm:text-base">
                  <AlertCircle className="h-4 w-4 inline-block mr-1 text-primary" />
                  <strong className="text-foreground">Delegation insight:</strong> {reason.delegationLink}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
